const DRAFT_FIELDS = ['email', 'userName', 'gender', 'country', 'birthday', 'language'];

export const buildSafeRegistrationDraft = (values = {}) =>
  DRAFT_FIELDS.reduce((draft, field) => {
    if (values[field] !== undefined) draft[field] = values[field];
    return draft;
  }, {});

export const beginRegistrationSubmission = (submittingRef) => {
  if (submittingRef.current) return false;
  submittingRef.current = true;
  return true;
};
